import LoginPage from "./LoginPage";

export { LoginPage };

export default LoginPage;
